// import React, { useEffect, useRef, useState } from "react";
// import banner1 from '../../../assets/website/images/banner1.png';
// import banner2 from '../../../assets/website/images/banner2.png';
// import banner3 from '../../../assets/website/images/banner3.png';
// import whyImg from '../../../assets/website/images/doctor.png';

// import industries1 from '../../../assets/website/images/industries1.jpg';
// import industries2 from '../../../assets/website/images/industries2.jpg';
// import industries3 from '../../../assets/website/images/industries3.jpg';
// import industries4 from '../../../assets/website/images/industries4.jpg';
// import HowWorkImg from '../../../assets/website/images/how-work-img.jpg';
// import { createSlider } from '../../../utils/commonfunction';
// import WebsiteTestimonials from "../common/websitedoctors";
// import { useTranslation } from "react-i18next";
// import Inquiry from "../common/inquiry";
// import { useSelector } from "react-redux";
// import { setTitle } from "../../../utils/commonfunction";
// import { Link, useLocation } from "react-router-dom";
// import WebsiteDoctors from "../common/websitedoctors";
// import WebsiteCenter from "../common/webisteCenter";


// function WebsiteHomePage() {
//   const { t } = useTranslation();
//   const BannerHomeSliderRef = useRef();
//   const BannerHomeSliderRef2 = useRef();
//   const BannerHomeSliderRef3 = useRef();
//   const location = useLocation();
//   const [getGlobalData, setGlobalData] = useState({});
//   const howItWorksRef = useRef();
//   const myGlobalData = useSelector((state) => state.globalData?.data);

//   useEffect(() => {
//     if (myGlobalData) {
//       const settingsData = JSON.parse(myGlobalData);
//       setGlobalData(settingsData);
//       setTitle(settingsData.title);
//     }

//   }, [myGlobalData]);

//   useEffect(() => {
//     if (howItWorksRef.current && window.location.hash.includes("#how-it-work")) {
//       const body = document.querySelector('body, html');
//       if(body.scrollTop <= 10){
//         body.scrollTop = howItWorksRef.current?.offsetTop || 0;
//       }
//     }
   
//   }, [howItWorksRef.current, location]);

//   useEffect(() => {
//     if (BannerHomeSliderRef?.current) {
//       createSlider(`#BannerHomeSliderRef`, {
//         loop: true,
//         margin: 20,
//         nav: true,
//         dots: false,
//         responsive: {
//           0: {
//             items: 1
//           },
//           600: {
//             items: 2
//           },
//           1000: {
//             items: 3
//           }
//         }
//       });
//     }
//   }, [BannerHomeSliderRef]);

//   useEffect(() => {
//     if (BannerHomeSliderRef2?.current) {
//       createSlider(`#BannerHomeSliderRef2`, {
//         loop: true,
//         margin: 20,
//         nav: true,
//         dots: false,
//         responsive: {
//           0: {
//             items: 1
//           },
//           600: {
//             items: 3
//           },
//           1000: {
//             items: 4
//           }
//         }
//       });
//     }
//   }, [BannerHomeSliderRef2]);

//   useEffect(() => {
//     if (BannerHomeSliderRef3?.current) {
//       createSlider(`#BannerHomeSliderRef3`, {
//         loop: true,
//         margin: 20,
//         nav: true,
//         dots: true,
//         responsive: {
//           0: {
//             items: 1
//           },
//           600: {
//             items: 1
//           },
//           1000: {
//             items: 1
//           }
//         }
//       });
//     }
//   }, [BannerHomeSliderRef3]);
//   return (
//     <div className="home-page-section">
//       <section className="home-hero-section">
//         <div className="home-hero-section-in">
//           <div className="container">
//             <div className="home-hero-text">
//               <h6>Your Trusted Healthcare Partner</h6>
//               <h1>Consult Experienced Doctors Anytime, Anywhere</h1>
//               <p>Get expert medical advice from qualified doctors through secure and seamless online consultations. Your health, our priority.</p>
//               {/* <Link to={`/inquiry`} className="btn btn-primary">Inquiry</Link> */}
//             </div>
//           </div>
//         </div>
//       </section>
//       <WebsiteCenter id="center1" />
//       {/* <section id="about_us" className="why-choose-sec section-padding">
//         <div className="container">
//           <div className="row align-items-center justify-content-between">
//             <div className="col-md-5">
//               <div className="why-choose-text">
//                 <div className="heading-section d-flex flex-column gap-3 mb-5">
//                   <h4>Why Choose Our Consultation Services?</h4>
//                   <p>We provide accessible, professional, and reliable healthcare consultations to meet your medical needs from the comfort of your home.</p>
//                 </div>
//                 <div className="why-choose-point d-flex row m-0">
//                   <article>
//                     <figure>
//                       <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
//                         <path d="M30 31.5H28.7C27.4 31.5 26.1 32 25.2 32.9L22.3 35.7C21 37 18.9 37 17.6 35.7L14.8 32.9C13.9 32 12.6 31.5 11.3 31.5H10C7.2 31.5 5 29.3 5 26.5V8.3C5 5.6 7.2 3.4 10 3.4H30C32.8 3.4 35 5.6 35 8.3V26.5C35 29.2 32.8 31.5 30 31.5Z" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
//                         <path d="M20 22.5C22.5 22.5 24.5 20.5 24.5 18C24.5 15.5 22.5 13.5 20 13.5C17.5 13.5 15.5 15.5 15.5 18C15.5 20.5 17.5 22.5 20 22.5Z" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
//                         <path d="M28 30C28 27 25 24.5 20 24.5C15 24.5 12 27 12 30" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
//                       </svg>
//                     </figure>
//                     <figcaption>
//                       <h4>24/7 Availability</h4>
//                     </figcaption>
//                   </article>
//                   <article>
//                     <figure>
//                       <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
//                         <path d="M30 31.5H28.7C27.4 31.5 26.1 32 25.2 32.9L22.3 35.7C21 37 18.9 37 17.6 35.7L14.8 32.9C13.9 32 12.6 31.5 11.3 31.5H10C7.2 31.5 5 29.3 5 26.5V8.3C5 5.6 7.2 3.4 10 3.4H30C32.8 3.4 35 5.6 35 8.3V26.5C35 29.2 32.8 31.5 30 31.5Z" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
//                         <path d="M20 22.5C22.5 22.5 24.5 20.5 24.5 18C24.5 15.5 22.5 13.5 20 13.5C17.5 13.5 15.5 15.5 15.5 18C15.5 20.5 17.5 22.5 20 22.5Z" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
//                         <path d="M28 30C28 27 25 24.5 20 24.5C15 24.5 12 27 12 30" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
//                       </svg>
//                     </figure>
//                     <figcaption>
//                       <h4>Secure & Confidential</h4>
//                     </figcaption>
//                   </article>
//                   <article>
//                     <figure>
//                       <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http:www.w3.org/2000/svg">
//                         <path d="M15.2663 18.1163C15.0996 18.0997 14.8996 18.0997 14.7163 18.1163C10.7496 17.983 7.59961 14.733 7.59961 10.733C7.59961 6.64967 10.8996 3.33301 14.9996 3.33301C19.0829 3.33301 22.3996 6.64967 22.3996 10.733C22.3829 14.733 19.2329 17.983 15.2663 18.1163Z" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
//                         <path d="M27.3505 6.66699C30.5838 6.66699 33.1838 9.28366 33.1838 12.5003C33.1838 15.6503 30.6838 18.217 27.5671 18.3337C27.4338 18.317 27.2838 18.317 27.1338 18.3337" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
//                         <path d="M6.9332 24.267C2.89987 26.967 2.89987 31.367 6.9332 34.0503C11.5165 37.117 19.0332 37.117 23.6165 34.0503C27.6499 31.3503 27.6499 26.9503 23.6165 24.267C19.0499 21.217 11.5332 21.217 6.9332 24.267Z" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
//                         <path d="M30.5664 33.333C31.7664 33.083 32.8997 32.5997 33.8331 31.883C36.4331 29.933 36.4331 26.7163 33.8331 24.7663C32.9164 24.0663 31.7997 23.5997 30.6164 23.333" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
//                       </svg>
//                     </figure>
//                     <figcaption>
//                       <h4>User-Friendly Platform</h4>
//                     </figcaption>
//                   </article>
//                   <article>
//                     <figure>
//                       <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
//                         <path d="M35 15V5H25" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
//                         <path d="M5 25V35H15" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
//                         <path d="M35 5L22.5 17.5" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
//                         <path d="M17.5 22.5L5 35" stroke="#E42375" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
//                       </svg>
//                     </figure>
//                     <figcaption>
//                       <h4>Affordable & Scalable</h4>
//                     </figcaption>
//                   </article>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-6">
//               <figure>
//                 <img src={whyImg} alt="Doctor Consultation" className="img-fluid" />
//               </figure>
//             </div>
//           </div>
//         </div>
//       </section> */}
//       {/* <WebsiteFeaturedOutlet /> */}
//       <section id="how-it-work" ref={howItWorksRef} className="how-it-work-sec section-padding">
//         <div className="container">
//           <div className="row justify-content-between">
//             <div className="col-md-6">
//               <div className="heading-section d-flex flex-column gap-2 mb-5">
//                 <h6>How It Works?</h6>
//                 <h4>Simple Steps to Your Consultation</h4>
//               </div>
//               <div className="how-it-row row">
//                 <div className="col-md-6">
//                   <article>
//                     <span>1</span>
//                     <h4>Sign Up</h4>
//                     <p>Create an account and provide your medical details.</p>
//                   </article>
//                 </div>
//                 <div className="col-md-6">
//                   <article>
//                     <span>2</span>
//                     <h4>Choose a Doctor</h4>
//                     <p>Select from a wide range of experienced specialists.</p>
//                   </article>
//                 </div>
//                 <div className="col-md-6">
//                   <article>
//                     <span>3</span>
//                     <h4>Book an Appointment</h4>
//                     <p>Pick a suitable time for your online consultation.</p>
//                   </article>
//                 </div>
//                 <div className="col-md-6">
//                   <article>
//                     <span>4</span>
//                     <h4>Consult & Get Prescriptions</h4>
//                     <p>Have a secure video consultation and receive prescriptions instantly.</p>
//                   </article>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-5">
//               <figure>
//                 <img src={whyImg} alt="Online Consultation" className="img-fluid" />
//               </figure>
//             </div>
//           </div>
//         </div>
//       </section>
//       {/* <WebsiteDoctors id="doctor-1" /> */}
//       <Inquiry id="inquiry" />      
//     </div>


//   );
// }

// export default WebsiteHomePage;


import React from 'react';
import { Link } from 'react-router-dom';

function WebsiteHomePage() {
  return (
    <div id="home" className="container py-5">
      <h1>Welcome! Home page of Wellness App :)</h1>
      {/* <Link className='btn btn-outline-success mt-3' to={'/admin/login'}>Go to admin</Link> */}
    </div>
  );
}

export default WebsiteHomePage;
